import React from 'react';
import { WrapperFlex, Button } from '@unimed-fesp/components';

import { ContentText } from './styles';

const BodyCopyUsuarioEspelho = ({ userName = '' }) => {
  return (
    <ContentText>
      Deseja realmente copiar a parametrização do usuário
      <strong>{` ${userName}`}</strong>?
      <br />A parametrização atual e o perfil serão <strong>alterados</strong>.
    </ContentText>
  );
};

const FooterCopyUsuarioEspelho = ({ closeModal, onClickOk }) => {
  return (
    <WrapperFlex justifySpaceAround minWidth={250}>
      <Button tipo="secondary" onClick={closeModal} width={100} justifyCenter>
        não
      </Button>
      <Button onClick={onClickOk} width={100} justifyCenter>
        sim
      </Button>
    </WrapperFlex>
  );
};

export default { BodyCopyUsuarioEspelho, FooterCopyUsuarioEspelho };
